import SingleReminder from './SingleReminder';

export default SingleReminder;
